/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Timestamp } from "./google/protobuf/timestamp";
import { Error, ErrorResponse, QueryRequest, IdRequest } from "./base";

export const protobufPackage = "traverse";

export interface GroupingTerminationRequest {
  token: string;
  accountId: number;
}

export interface SubgroupingRequest {
  token: string;
  linkCode: string;
}

export interface LinkResponse {
  error: Error | undefined;
  link: string;
}

export interface SubgroupingLinkParametersRequest {
  token: string;
  duration: SubgroupingLinkParametersRequest_LinkDuration;
}

export enum SubgroupingLinkParametersRequest_LinkDuration {
  OneDay = 0,
  OneWeek = 1,
  OneMonth = 2,
  Indefinite = 3,
  UNRECOGNIZED = -1,
}

export function subgroupingLinkParametersRequest_LinkDurationFromJSON(
  object: any
): SubgroupingLinkParametersRequest_LinkDuration {
  switch (object) {
    case 0:
    case "OneDay":
      return SubgroupingLinkParametersRequest_LinkDuration.OneDay;
    case 1:
    case "OneWeek":
      return SubgroupingLinkParametersRequest_LinkDuration.OneWeek;
    case 2:
    case "OneMonth":
      return SubgroupingLinkParametersRequest_LinkDuration.OneMonth;
    case 3:
    case "Indefinite":
      return SubgroupingLinkParametersRequest_LinkDuration.Indefinite;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SubgroupingLinkParametersRequest_LinkDuration.UNRECOGNIZED;
  }
}

export function subgroupingLinkParametersRequest_LinkDurationToJSON(
  object: SubgroupingLinkParametersRequest_LinkDuration
): string {
  switch (object) {
    case SubgroupingLinkParametersRequest_LinkDuration.OneDay:
      return "OneDay";
    case SubgroupingLinkParametersRequest_LinkDuration.OneWeek:
      return "OneWeek";
    case SubgroupingLinkParametersRequest_LinkDuration.OneMonth:
      return "OneMonth";
    case SubgroupingLinkParametersRequest_LinkDuration.Indefinite:
      return "Indefinite";
    default:
      return "UNKNOWN";
  }
}

export interface Account {
  id: number;
  created: Date | undefined;
  updated: Date | undefined;
  deleted: Date | undefined;
  name: string;
  accountType: Account_AccountType;
  nurseEnabled: boolean;
  reportingTo: Account[];
  subcontractors: Account[];
  roughEmployeeCount: string;
  estimatedTestRequirement: string;
  addressStreet: string;
  addressCity: string;
  addressState: string;
  addressPostalCode: string;
  connectionURL: string;
  connectionInviteCode: string;
  connectionExpirationDate: Date | undefined;
  testsAvailable: number;
}

export enum Account_AccountType {
  Standard = 0,
  Referer = 1,
  UNRECOGNIZED = -1,
}

export function account_AccountTypeFromJSON(object: any): Account_AccountType {
  switch (object) {
    case 0:
    case "Standard":
      return Account_AccountType.Standard;
    case 1:
    case "Referer":
      return Account_AccountType.Referer;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Account_AccountType.UNRECOGNIZED;
  }
}

export function account_AccountTypeToJSON(object: Account_AccountType): string {
  switch (object) {
    case Account_AccountType.Standard:
      return "Standard";
    case Account_AccountType.Referer:
      return "Referer";
    default:
      return "UNKNOWN";
  }
}

export interface AccountRequest {
  token: string;
  account: Account | undefined;
}

export interface AccountResponse {
  error: Error | undefined;
  account: Account | undefined;
}

export interface AccountListResponse {
  error: Error | undefined;
  accounts: Account[];
}

const baseGroupingTerminationRequest: object = { token: "", accountId: 0 };

export const GroupingTerminationRequest = {
  encode(
    message: GroupingTerminationRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    if (message.accountId !== 0) {
      writer.uint32(16).int64(message.accountId);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): GroupingTerminationRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseGroupingTerminationRequest,
    } as GroupingTerminationRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        case 2:
          message.accountId = longToNumber(reader.int64() as Long);
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): GroupingTerminationRequest {
    const message = {
      ...baseGroupingTerminationRequest,
    } as GroupingTerminationRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.accountId =
      object.accountId !== undefined && object.accountId !== null
        ? Number(object.accountId)
        : 0;
    return message;
  },

  toJSON(message: GroupingTerminationRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    message.accountId !== undefined && (obj.accountId = message.accountId);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<GroupingTerminationRequest>, I>>(
    object: I
  ): GroupingTerminationRequest {
    const message = {
      ...baseGroupingTerminationRequest,
    } as GroupingTerminationRequest;
    message.token = object.token ?? "";
    message.accountId = object.accountId ?? 0;
    return message;
  },
};

const baseSubgroupingRequest: object = { token: "", linkCode: "" };

export const SubgroupingRequest = {
  encode(
    message: SubgroupingRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    if (message.linkCode !== "") {
      writer.uint32(18).string(message.linkCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubgroupingRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseSubgroupingRequest } as SubgroupingRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        case 2:
          message.linkCode = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): SubgroupingRequest {
    const message = { ...baseSubgroupingRequest } as SubgroupingRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.linkCode =
      object.linkCode !== undefined && object.linkCode !== null
        ? String(object.linkCode)
        : "";
    return message;
  },

  toJSON(message: SubgroupingRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    message.linkCode !== undefined && (obj.linkCode = message.linkCode);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<SubgroupingRequest>, I>>(
    object: I
  ): SubgroupingRequest {
    const message = { ...baseSubgroupingRequest } as SubgroupingRequest;
    message.token = object.token ?? "";
    message.linkCode = object.linkCode ?? "";
    return message;
  },
};

const baseLinkResponse: object = { link: "" };

export const LinkResponse = {
  encode(
    message: LinkResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(10).fork()).ldelim();
    }
    if (message.link !== "") {
      writer.uint32(18).string(message.link);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LinkResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseLinkResponse } as LinkResponse;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.error = Error.decode(reader, reader.uint32());
          break;
        case 2:
          message.link = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): LinkResponse {
    const message = { ...baseLinkResponse } as LinkResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromJSON(object.error)
        : undefined;
    message.link =
      object.link !== undefined && object.link !== null
        ? String(object.link)
        : "";
    return message;
  },

  toJSON(message: LinkResponse): unknown {
    const obj: any = {};
    message.error !== undefined &&
      (obj.error = message.error ? Error.toJSON(message.error) : undefined);
    message.link !== undefined && (obj.link = message.link);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<LinkResponse>, I>>(
    object: I
  ): LinkResponse {
    const message = { ...baseLinkResponse } as LinkResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromPartial(object.error)
        : undefined;
    message.link = object.link ?? "";
    return message;
  },
};

const baseSubgroupingLinkParametersRequest: object = { token: "", duration: 0 };

export const SubgroupingLinkParametersRequest = {
  encode(
    message: SubgroupingLinkParametersRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(18).string(message.token);
    }
    if (message.duration !== 0) {
      writer.uint32(8).int32(message.duration);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): SubgroupingLinkParametersRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseSubgroupingLinkParametersRequest,
    } as SubgroupingLinkParametersRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          message.token = reader.string();
          break;
        case 1:
          message.duration = reader.int32() as any;
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): SubgroupingLinkParametersRequest {
    const message = {
      ...baseSubgroupingLinkParametersRequest,
    } as SubgroupingLinkParametersRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.duration =
      object.duration !== undefined && object.duration !== null
        ? subgroupingLinkParametersRequest_LinkDurationFromJSON(object.duration)
        : 0;
    return message;
  },

  toJSON(message: SubgroupingLinkParametersRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    message.duration !== undefined &&
      (obj.duration = subgroupingLinkParametersRequest_LinkDurationToJSON(
        message.duration
      ));
    return obj;
  },

  fromPartial<
    I extends Exact<DeepPartial<SubgroupingLinkParametersRequest>, I>
  >(object: I): SubgroupingLinkParametersRequest {
    const message = {
      ...baseSubgroupingLinkParametersRequest,
    } as SubgroupingLinkParametersRequest;
    message.token = object.token ?? "";
    message.duration = object.duration ?? 0;
    return message;
  },
};

const baseAccount: object = {
  id: 0,
  name: "",
  accountType: 0,
  nurseEnabled: false,
  roughEmployeeCount: "",
  estimatedTestRequirement: "",
  addressStreet: "",
  addressCity: "",
  addressState: "",
  addressPostalCode: "",
  connectionURL: "",
  connectionInviteCode: "",
  testsAvailable: 0,
};

export const Account = {
  encode(
    message: Account,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.created !== undefined) {
      Timestamp.encode(
        toTimestamp(message.created),
        writer.uint32(18).fork()
      ).ldelim();
    }
    if (message.updated !== undefined) {
      Timestamp.encode(
        toTimestamp(message.updated),
        writer.uint32(26).fork()
      ).ldelim();
    }
    if (message.deleted !== undefined) {
      Timestamp.encode(
        toTimestamp(message.deleted),
        writer.uint32(34).fork()
      ).ldelim();
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.accountType !== 0) {
      writer.uint32(56).int32(message.accountType);
    }
    if (message.nurseEnabled === true) {
      writer.uint32(176).bool(message.nurseEnabled);
    }
    for (const v of message.reportingTo) {
      Account.encode(v!, writer.uint32(146).fork()).ldelim();
    }
    for (const v of message.subcontractors) {
      Account.encode(v!, writer.uint32(82).fork()).ldelim();
    }
    if (message.roughEmployeeCount !== "") {
      writer.uint32(90).string(message.roughEmployeeCount);
    }
    if (message.estimatedTestRequirement !== "") {
      writer.uint32(98).string(message.estimatedTestRequirement);
    }
    if (message.addressStreet !== "") {
      writer.uint32(106).string(message.addressStreet);
    }
    if (message.addressCity !== "") {
      writer.uint32(114).string(message.addressCity);
    }
    if (message.addressState !== "") {
      writer.uint32(122).string(message.addressState);
    }
    if (message.addressPostalCode !== "") {
      writer.uint32(130).string(message.addressPostalCode);
    }
    if (message.connectionURL !== "") {
      writer.uint32(170).string(message.connectionURL);
    }
    if (message.connectionInviteCode !== "") {
      writer.uint32(154).string(message.connectionInviteCode);
    }
    if (message.connectionExpirationDate !== undefined) {
      Timestamp.encode(
        toTimestamp(message.connectionExpirationDate),
        writer.uint32(162).fork()
      ).ldelim();
    }
    if (message.testsAvailable !== 0) {
      writer.uint32(136).int64(message.testsAvailable);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Account {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseAccount } as Account;
    message.reportingTo = [];
    message.subcontractors = [];
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = longToNumber(reader.int64() as Long);
          break;
        case 2:
          message.created = fromTimestamp(
            Timestamp.decode(reader, reader.uint32())
          );
          break;
        case 3:
          message.updated = fromTimestamp(
            Timestamp.decode(reader, reader.uint32())
          );
          break;
        case 4:
          message.deleted = fromTimestamp(
            Timestamp.decode(reader, reader.uint32())
          );
          break;
        case 5:
          message.name = reader.string();
          break;
        case 7:
          message.accountType = reader.int32() as any;
          break;
        case 22:
          message.nurseEnabled = reader.bool();
          break;
        case 18:
          message.reportingTo.push(Account.decode(reader, reader.uint32()));
          break;
        case 10:
          message.subcontractors.push(Account.decode(reader, reader.uint32()));
          break;
        case 11:
          message.roughEmployeeCount = reader.string();
          break;
        case 12:
          message.estimatedTestRequirement = reader.string();
          break;
        case 13:
          message.addressStreet = reader.string();
          break;
        case 14:
          message.addressCity = reader.string();
          break;
        case 15:
          message.addressState = reader.string();
          break;
        case 16:
          message.addressPostalCode = reader.string();
          break;
        case 21:
          message.connectionURL = reader.string();
          break;
        case 19:
          message.connectionInviteCode = reader.string();
          break;
        case 20:
          message.connectionExpirationDate = fromTimestamp(
            Timestamp.decode(reader, reader.uint32())
          );
          break;
        case 17:
          message.testsAvailable = longToNumber(reader.int64() as Long);
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): Account {
    const message = { ...baseAccount } as Account;
    message.id =
      object.id !== undefined && object.id !== null ? Number(object.id) : 0;
    message.created =
      object.created !== undefined && object.created !== null
        ? fromJsonTimestamp(object.created)
        : undefined;
    message.updated =
      object.updated !== undefined && object.updated !== null
        ? fromJsonTimestamp(object.updated)
        : undefined;
    message.deleted =
      object.deleted !== undefined && object.deleted !== null
        ? fromJsonTimestamp(object.deleted)
        : undefined;
    message.name =
      object.name !== undefined && object.name !== null
        ? String(object.name)
        : "";
    message.accountType =
      object.accountType !== undefined && object.accountType !== null
        ? account_AccountTypeFromJSON(object.accountType)
        : 0;
    message.nurseEnabled =
      object.nurseEnabled !== undefined && object.nurseEnabled !== null
        ? Boolean(object.nurseEnabled)
        : false;
    message.reportingTo = (object.reportingTo ?? []).map((e: any) =>
      Account.fromJSON(e)
    );
    message.subcontractors = (object.subcontractors ?? []).map((e: any) =>
      Account.fromJSON(e)
    );
    message.roughEmployeeCount =
      object.roughEmployeeCount !== undefined &&
      object.roughEmployeeCount !== null
        ? String(object.roughEmployeeCount)
        : "";
    message.estimatedTestRequirement =
      object.estimatedTestRequirement !== undefined &&
      object.estimatedTestRequirement !== null
        ? String(object.estimatedTestRequirement)
        : "";
    message.addressStreet =
      object.addressStreet !== undefined && object.addressStreet !== null
        ? String(object.addressStreet)
        : "";
    message.addressCity =
      object.addressCity !== undefined && object.addressCity !== null
        ? String(object.addressCity)
        : "";
    message.addressState =
      object.addressState !== undefined && object.addressState !== null
        ? String(object.addressState)
        : "";
    message.addressPostalCode =
      object.addressPostalCode !== undefined &&
      object.addressPostalCode !== null
        ? String(object.addressPostalCode)
        : "";
    message.connectionURL =
      object.connectionURL !== undefined && object.connectionURL !== null
        ? String(object.connectionURL)
        : "";
    message.connectionInviteCode =
      object.connectionInviteCode !== undefined &&
      object.connectionInviteCode !== null
        ? String(object.connectionInviteCode)
        : "";
    message.connectionExpirationDate =
      object.connectionExpirationDate !== undefined &&
      object.connectionExpirationDate !== null
        ? fromJsonTimestamp(object.connectionExpirationDate)
        : undefined;
    message.testsAvailable =
      object.testsAvailable !== undefined && object.testsAvailable !== null
        ? Number(object.testsAvailable)
        : 0;
    return message;
  },

  toJSON(message: Account): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.created !== undefined &&
      (obj.created = message.created.toISOString());
    message.updated !== undefined &&
      (obj.updated = message.updated.toISOString());
    message.deleted !== undefined &&
      (obj.deleted = message.deleted.toISOString());
    message.name !== undefined && (obj.name = message.name);
    message.accountType !== undefined &&
      (obj.accountType = account_AccountTypeToJSON(message.accountType));
    message.nurseEnabled !== undefined &&
      (obj.nurseEnabled = message.nurseEnabled);
    if (message.reportingTo) {
      obj.reportingTo = message.reportingTo.map((e) =>
        e ? Account.toJSON(e) : undefined
      );
    } else {
      obj.reportingTo = [];
    }
    if (message.subcontractors) {
      obj.subcontractors = message.subcontractors.map((e) =>
        e ? Account.toJSON(e) : undefined
      );
    } else {
      obj.subcontractors = [];
    }
    message.roughEmployeeCount !== undefined &&
      (obj.roughEmployeeCount = message.roughEmployeeCount);
    message.estimatedTestRequirement !== undefined &&
      (obj.estimatedTestRequirement = message.estimatedTestRequirement);
    message.addressStreet !== undefined &&
      (obj.addressStreet = message.addressStreet);
    message.addressCity !== undefined &&
      (obj.addressCity = message.addressCity);
    message.addressState !== undefined &&
      (obj.addressState = message.addressState);
    message.addressPostalCode !== undefined &&
      (obj.addressPostalCode = message.addressPostalCode);
    message.connectionURL !== undefined &&
      (obj.connectionURL = message.connectionURL);
    message.connectionInviteCode !== undefined &&
      (obj.connectionInviteCode = message.connectionInviteCode);
    message.connectionExpirationDate !== undefined &&
      (obj.connectionExpirationDate =
        message.connectionExpirationDate.toISOString());
    message.testsAvailable !== undefined &&
      (obj.testsAvailable = message.testsAvailable);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<Account>, I>>(object: I): Account {
    const message = { ...baseAccount } as Account;
    message.id = object.id ?? 0;
    message.created = object.created ?? undefined;
    message.updated = object.updated ?? undefined;
    message.deleted = object.deleted ?? undefined;
    message.name = object.name ?? "";
    message.accountType = object.accountType ?? 0;
    message.nurseEnabled = object.nurseEnabled ?? false;
    message.reportingTo =
      object.reportingTo?.map((e) => Account.fromPartial(e)) || [];
    message.subcontractors =
      object.subcontractors?.map((e) => Account.fromPartial(e)) || [];
    message.roughEmployeeCount = object.roughEmployeeCount ?? "";
    message.estimatedTestRequirement = object.estimatedTestRequirement ?? "";
    message.addressStreet = object.addressStreet ?? "";
    message.addressCity = object.addressCity ?? "";
    message.addressState = object.addressState ?? "";
    message.addressPostalCode = object.addressPostalCode ?? "";
    message.connectionURL = object.connectionURL ?? "";
    message.connectionInviteCode = object.connectionInviteCode ?? "";
    message.connectionExpirationDate =
      object.connectionExpirationDate ?? undefined;
    message.testsAvailable = object.testsAvailable ?? 0;
    return message;
  },
};

const baseAccountRequest: object = { token: "" };

export const AccountRequest = {
  encode(
    message: AccountRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    if (message.account !== undefined) {
      Account.encode(message.account, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AccountRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseAccountRequest } as AccountRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        case 2:
          message.account = Account.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccountRequest {
    const message = { ...baseAccountRequest } as AccountRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.account =
      object.account !== undefined && object.account !== null
        ? Account.fromJSON(object.account)
        : undefined;
    return message;
  },

  toJSON(message: AccountRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    message.account !== undefined &&
      (obj.account = message.account
        ? Account.toJSON(message.account)
        : undefined);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<AccountRequest>, I>>(
    object: I
  ): AccountRequest {
    const message = { ...baseAccountRequest } as AccountRequest;
    message.token = object.token ?? "";
    message.account =
      object.account !== undefined && object.account !== null
        ? Account.fromPartial(object.account)
        : undefined;
    return message;
  },
};

const baseAccountResponse: object = {};

export const AccountResponse = {
  encode(
    message: AccountResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(10).fork()).ldelim();
    }
    if (message.account !== undefined) {
      Account.encode(message.account, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AccountResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseAccountResponse } as AccountResponse;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.error = Error.decode(reader, reader.uint32());
          break;
        case 2:
          message.account = Account.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccountResponse {
    const message = { ...baseAccountResponse } as AccountResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromJSON(object.error)
        : undefined;
    message.account =
      object.account !== undefined && object.account !== null
        ? Account.fromJSON(object.account)
        : undefined;
    return message;
  },

  toJSON(message: AccountResponse): unknown {
    const obj: any = {};
    message.error !== undefined &&
      (obj.error = message.error ? Error.toJSON(message.error) : undefined);
    message.account !== undefined &&
      (obj.account = message.account
        ? Account.toJSON(message.account)
        : undefined);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<AccountResponse>, I>>(
    object: I
  ): AccountResponse {
    const message = { ...baseAccountResponse } as AccountResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromPartial(object.error)
        : undefined;
    message.account =
      object.account !== undefined && object.account !== null
        ? Account.fromPartial(object.account)
        : undefined;
    return message;
  },
};

const baseAccountListResponse: object = {};

export const AccountListResponse = {
  encode(
    message: AccountListResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.accounts) {
      Account.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AccountListResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseAccountListResponse } as AccountListResponse;
    message.accounts = [];
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.error = Error.decode(reader, reader.uint32());
          break;
        case 2:
          message.accounts.push(Account.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccountListResponse {
    const message = { ...baseAccountListResponse } as AccountListResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromJSON(object.error)
        : undefined;
    message.accounts = (object.accounts ?? []).map((e: any) =>
      Account.fromJSON(e)
    );
    return message;
  },

  toJSON(message: AccountListResponse): unknown {
    const obj: any = {};
    message.error !== undefined &&
      (obj.error = message.error ? Error.toJSON(message.error) : undefined);
    if (message.accounts) {
      obj.accounts = message.accounts.map((e) =>
        e ? Account.toJSON(e) : undefined
      );
    } else {
      obj.accounts = [];
    }
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<AccountListResponse>, I>>(
    object: I
  ): AccountListResponse {
    const message = { ...baseAccountListResponse } as AccountListResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromPartial(object.error)
        : undefined;
    message.accounts =
      object.accounts?.map((e) => Account.fromPartial(e)) || [];
    return message;
  },
};

export interface AccountService {
  GetAccounts(request: QueryRequest): Promise<AccountListResponse>;
  DeleteAccount(request: IdRequest): Promise<ErrorResponse>;
  UpdateAccount(request: AccountRequest): Promise<ErrorResponse>;
  CreateSubgroupingLink(
    request: SubgroupingLinkParametersRequest
  ): Promise<LinkResponse>;
  GetLinkAccountInformation(
    request: SubgroupingRequest
  ): Promise<AccountResponse>;
  AcceptSubgrouping(request: SubgroupingRequest): Promise<ErrorResponse>;
  TerminateGrouping(
    request: GroupingTerminationRequest
  ): Promise<ErrorResponse>;
  NurseSwitchAccount(request: IdRequest): Promise<ErrorResponse>;
}

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >;

function toTimestamp(date: Date): Timestamp {
  const seconds = date.getTime() / 1_000;
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = t.seconds * 1_000;
  millis += t.nanos / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}
